import { render, staticRenderFns } from "./denomTable.vue?vue&type=template&id=79389c7c&scoped=true"
import script from "./denomTable.vue?vue&type=script&lang=js"
export * from "./denomTable.vue?vue&type=script&lang=js"
import style0 from "./denomTable.vue?vue&type=style&index=0&id=79389c7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79389c7c",
  null
  
)

export default component.exports